import { types } from 'mobx-state-tree'

export const TopicPctCorrectSummary = types.model('TopicPctCorrectSummary').props({
  topic_id: types.number,
  title: types.string,
  pct_correct: types.number,
  image_url: types.maybeNull(types.string),
  pack_color: types.maybeNull(types.string),
})
